import { QueryClient } from '@tanstack/react-query'

let queryClient: QueryClient

export const getQueryClient = () => {
  if (!queryClient || typeof window === 'undefined') {
    queryClient = new QueryClient()
  }
  return queryClient
}
